export default {
  title: 'Nichts verpassen!',
  description: 'Aktiviere Benachrichtigungen, um über deine Bestellung auf dem Laufenden zu bleiben.',
  buttons: {
    enable: 'Aktivieren',
  },
};
